import { z } from "zod";

import { EMPTY } from "~/shared/str";

function zPageSearch<T extends z.ZodSchema<string>>(actionType: T) {
  return z.object({
    filter: z.string().catch(EMPTY),
    currentAction: z
      .object({
        type: actionType,
        entityId: z.string().uuid(),
      })
      .nullable()
      .catch(null),
  });
}

type PageSearch<T extends string> = z.infer<ReturnType<typeof zPageSearch<z.ZodSchema<T>>>>;

export { zPageSearch };
export type { PageSearch };
